import { useState } from "react";
import { PageHead } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calendario } from "@/components/contab/Calendario";
import { CostiFissi, Parametri, Report } from "@/components/contab/Dati";

const T = ({ v, children }) => <TabsTrigger value={v} data-testid={`contab-tab-${v}`} className="data-[state=active]:bg-[#0D3B52] data-[state=active]:text-white">{children}</TabsTrigger>;
const Sub = ({ items, defaultValue }) => (
  <Tabs defaultValue={defaultValue}>
    <TabsList className="bg-white border border-[#E2DDD5] h-auto p-1 flex-wrap mb-5">{items.map(([v, l]) => <T key={v} v={v}>{l}</T>)}</TabsList>
    {items.map(([v, , el]) => <TabsContent key={v} value={v}>{el}</TabsContent>)}
  </Tabs>
);

export default function Contabilita() {
  const [sec, setSec] = useState("dati");
  return (
    <div data-testid="contabilita-page">
      <PageHead eyebrow="Gestione contabile" title="Contabilità" subtitle="Dati, report e spese casa. Tutti i dati vengono salvati e ogni voce è modificabile." />
      <Tabs value={sec} onValueChange={setSec}>
        <TabsList className="bg-[#0D3B52] h-auto p-1 mb-6">
          {[["dati", "1 · Dati"], ["report", "2 · Report"], ["casa", "3 · Spese casa"]].map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`contab-sec-${v}`} className="text-white/70 data-[state=active]:bg-[#B8860B] data-[state=active]:text-white px-5">{l}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="dati">
          <Sub defaultValue="calendario" items={[
            ["calendario", "1-1 Calendario giornaliero", <Calendario ambito="azienda" />],
            ["costi", "1-2 Costi fissi e tasse", <><CostiFissi /><div className="mt-8"><Parametri /></div></>],
            ["iva", "1-3 IVA giorno/mese/trimestre", <Report tipo="iva" testid="dati-iva" />],
            ["commissioni", "1-4 Commissioni", <Parametri />],
            ["impianto", "1-5 Impianto", <Report tipo="impianto" testid="dati-impianto" />],
          ]} />
        </TabsContent>
        <TabsContent value="report">
          <Sub defaultValue="cremazioni" items={[
            ["cremazioni", "2-1 Cremazioni", <Report tipo="cremazioni" testid="rep-cremazioni" />],
            ["economico", "2-2 Incassi e spese", <Report tipo="economico" testid="rep-economico" />],
            ["iva", "2-3 IVA", <Report tipo="iva" testid="rep-iva" />],
            ["generale", "2-4 Generale", <Report tipo="generale" testid="rep-generale" />],
            ["impianto", "2-5 Impianto", <Report tipo="impianto" testid="rep-impianto" />],
          ]} />
        </TabsContent>
        <TabsContent value="casa">
          <Sub defaultValue="registro" items={[
            ["registro", "3-1 Registro entrate/uscite", <Calendario ambito="casa" />],
            ["report", "Report casa", <Report tipo="casa" testid="rep-casa" />],
          ]} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
